export const SOURCE_TYPES = {
    GOOGLE_SHEETS: 'GOOGLE_SHEETS',
    YANDEX_DIRECT_STAT: 'YANDEX_DIRECT_STAT',
    VKONTAKTE_CAMPAIGN_STAT: 'VKONTAKTE_CAMPAIGN_STAT',
    BITRIX_UPLOAD: 'BITRIX_UPLOAD',
}

export const TARGET_TYPES = {
    GOOGLE_SHEETS: 'GOOGLE_SHEETS',
}

export const UPLOAD_TYPES = {
    SOURCE: "SOURCE",
    TARGET: "TARGET"
}

export const STAGES = {
    SOURCE: {
        name: 'SOURCE',
        index: 1,
        label: 'Источник',
        description: 'Выберите источник'
    },
    DATA_PROCESSOR: {
        name: 'DATA_PROCESSOR',
        index: 2,
        label: 'Обработка',
        description: 'Обработка данных'
    },
    TARGET: {
        name: 'TARGET',
        index: 3,
        label: 'Назначение',
        description: 'Выберите таблицу назначения'
    }
}

export const FILTER_CRITERIA_TYPES = {
    IS_TRUE: 'IS_TRUE',
    IS_FALSE: 'IS_FALSE'
}

export const DATE_TYPES = {
    EXACT: 'exact',
    OFFSET: 'offset'
}

export const OFFSET_TYPES = {
    MONTH: 'MONTH',
    DAYS: 'DAYS'
}